if (!customElements.get('signature-product-features')) {
  /**
   * Clones a single, randomly chosen <template> child into the DOM on connect.
   * Templates don't download their media, so only the picked banner is fetched.
   * The host stays display:contents (set inline) so the cloned promo remains a
   * direct grid/flex item of the surrounding promo <li>.
   */
  class SignatureProductFeatures extends HTMLElement {
    connectedCallback() {
      if (this.rendered) return;
      this.rendered = true;

      const templates = Array.from(this.children).filter((el) => el.tagName === 'TEMPLATE');
      if (templates.length === 0) return;

      const chosen = templates[Math.floor(Math.random() * templates.length)];

      // Drop the inert templates so only the chosen banner remains in the DOM.
      templates.forEach((template) => template.remove());

      this.appendChild(chosen.content.cloneNode(true));
    }
  }

  customElements.define('signature-product-features', SignatureProductFeatures);
}
